<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="財務查詢條件設定">
    <mat-toolbar class="h-9">
      <button class="btn" [class.btn-primary]="true" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button class="btn" [class.btn-seccess]="true" (click)="doTextArea(this.logMessage,'')">
        看LOG訊息
      </button>
      <button class="btn" [class.btn-seccess]="true" (click)="doTextArea(this.apiMessage,'')">
        看api回傳值
      </button>
    </mat-toolbar>
    <mat-tab-group [(selectedIndex)]="kindIndex">
      @for (tab of kindList; track tab) {
      <mat-tab [label]="tab.name"></mat-tab>
      }
    </mat-tab-group>
    <div class="jk-row-border" style="width: 350px">
      <app-jkcheckbox #scheduleCom class="jk-checkbox-border" [styleDisplay]="'flex'" label="加入定時作業"
        [(value)]="isSchedule">
      </app-jkcheckbox>

      @if(daterangeVisible){
      <app-jkdaterange #daterangeCom label="日期範圍" [(valueA)]="dateA" [(valueB)]="dateB" [showClearButton]="true">
      </app-jkdaterange>
      }
      @if(dateVisible){
      <app-jkdatefield #dateCom label="日期" [(value)]="date1" [showClearButton]="true" [visible]="dateVisible">
      </app-jkdatefield>
      }
      @if(accountVisible){
      <app-jkcombobox #accountCom class="jk-combobox-border" [styleDisplay]="'flex'" label="證券帳號" [(value)]="account"
        [visible]="accountVisible" [items]="accountList">
      </app-jkcombobox>
      }
      @if(futureAccountVisible){
      <app-jkcombobox #futureAccountCom class="jk-combobox-border" [styleDisplay]="'flex'" label="期貨帳號"
        [(value)]="futureAccount" [visible]="futureAccountVisible" [items]="futureAccountList">
      </app-jkcombobox>
      }
      @if(seaAccountVisible){
      <app-jkcombobox #seaAccountCom class="jk-combobox-border" [styleDisplay]="'flex'" label="海期帳號"
        [(value)]="seaAccount" [visible]="seaAccountVisible" [items]="seaAccountList">
      </app-jkcombobox>
      }
      @if(stklgVisible){
      <app-jkcombobox #stklg002Com class="jk-combobox-border" [styleDisplay]="'flex'" label="報價週期" [(value)]="stklg002"
        [items]="stklg002List">
      </app-jkcombobox>
      }
      @if ( marketVisible) {
      <button class="btn" (click)="doGetMarket()">
        更新上市櫃行情
      </button>
      }
      @if(stkmqVisible){
      <button class="btn" (click)="doGetRealBalanceReport()">
        更新證券即時庫存內容
      </button>
      }
      @if(groupVisible){
      <button class="btn" (click)="doSetGroupId()">
        設定報價群組
      </button>
      }
      @if(stkmyVisible){
      <button class="btn" (click)="doGetBalanceQuery()">
        更新集保庫存查詢
      </button>
      }
      @if(groupVisible){
      <app-jkbtnedit [label]="'股票群組代號'" [maintable]="'STKME'" [item]="'W01'" [(value)]="stockSrv.groupId"
        [valueExpr]="'ME001'" [width]="'60'" [displayExpr]="'ME002'"></app-jkbtnedit>
      }
      @if(stockVisible){
      <button class="btn" (click)="doGetProfitLossGWReport()">
        更新股票損益
      </button>
      }
      @if(stockVisible){
      <app-jkcombobox class="jk-combobox-border" [styleDisplay]="'flex'" label="損益類別" [(value)]="profitLoss"
        [items]="profitLossList">
      </app-jkcombobox>
      <app-jkcombobox class="jk-combobox-border" [styleDisplay]="'flex'" label="格式" [(value)]="profitLossFormat"
        [items]="profitLossFormatList">
      </app-jkcombobox>
      }
      @if(stkmrVisible){
      <button class="btn" (click)="doGetOpenInterest()">
        期貨未平倉更新
      </button>
      }
      @if(stkmxVisible){
      <button class="btn" (click)="doPassThrough('GetSeaOpenInterest','海期海選未平倉')">
        海期海選未平倉更新
      </button>
      }
      @if(nodeStockVisible){
        <mat-toolbar class="h-9 flex">
          <button class="btn" [class.btn-primary]="true" (click)="doStkpq08()">
            跳轉到 技術分析資料查詢與重計(stkpq08)
          </button>
        </mat-toolbar>
      }
      @if(miscVisible){
        <mat-toolbar class="h-9 flex">
        <button class="btn" [class.btn-primary]="true" (click)="doAfternoonService()">
          更新盤後資料
        </button>
        <button class="btn" [class.btn-primary]="true" (click)="doDayCheckoutService()">
          日結帳
        </button>

        <button class="btn" (click)="doGeneStktatb()">
          產生股票交易建立
        </button>
      </mat-toolbar>
      <mat-toolbar class="h-9 flex">
        <button class="btn" [class.btn-primary]="true" (click)="doOneKeyBeforeOrder()">
          一鍵更新下單前資訊(市場股票期貨)
        </button>
      </mat-toolbar>
      <mat-toolbar class="h-9 flex">
        <button class="btn" (click)="doPassThrough('info','取得系統資訊')">
          系統資訊
        </button>
        <button class="btn" (click)="doPassThrough('getMessage','取得下單主機LOG')">
          下單主機LOG
        </button>
        <button class="btn" (click)="doPassThrough('clearMessage','清除下單主機LOG')">
          清除下單主機LOG
        </button>
      </mat-toolbar>
      }
    </div>
  </mat-tab>
  <mat-tab #myTabDetail label="詳細資料">
    <!-- (rowClicked)="gridMain.agRowClicked($event)"
    (rowSelected)="gridMain.agRowSelected($event)"  -->
    <app-jkgridwin #jkgridwin (afterGridReady)="afterGridReady($event)" (afterQuery)="afterQuery()"
      (afterColumnDefs)="afterColumnDefs($event)"></app-jkgridwin>
  </mat-tab>
  <mat-tab #myOrder label="下單">
    <section>
      <!-- <mat-button-toggle-group name="ingredients" aria-label="Ingredients" [hideSingleSelectionIndicator]="false"
        [(value)]="orderType">
        <mat-button-toggle value="TS">股票</mat-button-toggle>
        <mat-button-toggle value="TF">期貨</mat-button-toggle>
        <mat-button-toggle value="OF">海期</mat-button-toggle>
      </mat-button-toggle-group> -->
      <app-jkbuttongroup [title]="''" [items]="orderTypeList" [(value)]="orderType">
      </app-jkbuttongroup>
    </section>
    <div>
      @if(stockOrderVisible){<app-tw-stock-order [stkmbSrv]="stkmbSrv"></app-tw-stock-order>}
      @if(futureOrderVisible){<app-future-order></app-future-order>}
      @if(seaFutureOrderVisible){<app-sea-future-order></app-sea-future-order>}
    </div>
  </mat-tab>
  <mat-tab #capitalWeb label="群益網頁">
    {{capitalBalanceUrl}}
    <iframe [src]="capitalBalanceUrl | safe: 'resourceUrl' " width="100%" height="800px">
    </iframe>

  </mat-tab>

</mat-tab-group>
